export enum AptProductGroups {
    Vulnerable = 'VULNERABILE - SYS',
    CombinedSale = 'vendita abbinata polizza',
    Appliance = 'ASS_ELETTRODOMESTICI',
    Implant = 'ASS_IMPIANTI',
    RcDanni = 'ASS_RC_DANNI',
    Utility = 'ASS_PAR_UTILITY',
}
